import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {
  maintenanceFailModeBasicInformationDefaultProps,
  maintenanceFailModeBasicInformationPropTypes,
} from '../proptypes/MaintenanceFailModePropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { MAINTENANCE_WARNING_PRIORITY } from '../../../../../config/constants';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';

const MaintenanceFailModeBasicInformationResource = ({
  description,
  category,
  subCategory,
  activity,
  priority,
  createDate,
}) => (
  <>
    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>

    <ResourceProperty label="Categoría:">
      {category ? category.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Subcategoría:">
      {subCategory ? subCategory.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Actividad:">
      {activity ? activity.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Prioridad:">
      {MAINTENANCE_WARNING_PRIORITY[priority].label || '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Creación:">
      {createDate
        ? tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT })
        : '-'}
    </ResourceProperty>
  </>
);

MaintenanceFailModeBasicInformationResource.propTypes =
  maintenanceFailModeBasicInformationPropTypes;

MaintenanceFailModeBasicInformationResource.defaultProps =
  maintenanceFailModeBasicInformationDefaultProps;

export default MaintenanceFailModeBasicInformationResource;
